import React from "react";

import FootballTable from "../../football/match/Table";
import H2h from "../../football/match/Linesup";
import Stats from "../../football/match/Stats";
import MatchLineup from "../../football/match/MatchLineup";
import InfoTable from "../../football/match/InfoTable";
import SummaryTable from "../../football/match/SummaryTable";
import Head from "../../football/match/Head";
import CommentaryWrap from "../../football/match/CommenaryWrap";
import News from "../../common/News";
import MatchPage from "../../football/match/MatchPage";
import MatchTimeline from "../../football/match/MatchTimeline";
import EditorialHeader from "../../football/match/EditorialHeader";

const MatchWidgetWrap = ({
  dataId,
  dataType,
  sport,
  difference,
  head,
  data,
  headData,
  otherData,
  baseUrl,
  loadCSS,
  setDataId,
  setDataType,
  setHead,
  setLeagueId,
  dataClient = false,
  websiteBaseUrl,
  dataPath,
  dataTitle,
  liveCentre = false,
  socketUrl = "",
  channel = "FootballMatch",
  event = `FootballMatchDetails`,
}) => {
  const withHead = (currentTab, Component, props = {}) =>
    head ? (
      <>
        <Head
          matchDetail={headData}
          difference={difference}
          sport={sport}
          dataClient={dataClient}
          id={dataId}
          currentTab={currentTab}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          title={dataTitle}
          socketUrl={socketUrl}
          channel={channel}
          event={event + `-${dataId}`}
        >
          <Component {...props} />
        </Head>
      </>
    ) : (
      <Component {...props} title={dataTitle} />
    );

  switch (dataType) {
    case "match-table":
      return withHead("table", FootballTable, {
        ServerData: data?.data,
        loadCSS,
        dataClient,
        websiteBaseUrl,
        dataPath,
        sport,
      });

    case "match-h2h":
      return withHead("h2h", H2h, {
        serverData: data?.data,
        loadCSS,
        setDataType,
        setDataId,
        setHead,
        setLeagueId,
        dataClient,
        liveCentre,
      });

    case "match-stats":
      return withHead("stats", Stats, {
        data: data?.data,
        loadCSS,
        dataClient,
      });

    case "match-lineup":
      // Self-contained widget with its own header (crest/coach/formation) — no generic Head wrap.
      return (
        <MatchLineup
          serverData={data?.data}
          dataId={dataId}
          baseUrl={baseUrl}
          sport={sport}
          difference={difference}
          loadCSS={loadCSS}
          dataClient={dataClient}
        />
      );

    case "match-info":
      return withHead("info", InfoTable, {
        data: data?.summary,
        difference,
        loadCSS,
        dataClient,
        matchDetail: headData,
      });

    case "match-timeline":
      return withHead("events", MatchTimeline, {
        data: data?.summary,
        loadCSS,
        dataClient,
        matchDetail: headData,
      });

    case "match-summary":
      return withHead("events", SummaryTable, {
        data: data?.summary,
        commData: otherData,
        id: dataId,
        loadCSS,
        dataClient,
      });

    case "match-com":
      return withHead("commentary", CommentaryWrap, {
        data,
        difference,
        loadCSS,
        dataClient,
        id: dataId,
        matchDetail: headData,
        baseUrl,
      });

    case "match-news":
      return withHead("news", News, {
        data,
        difference,
        loadCSS,
        dataClient,
        id: dataId,
        baseUrl,
      });

    case "match":
      return (
        head && (
          <Head
            matchDetail={headData}
            difference={difference}
            sport={sport}
            dataType={dataType}
            setDataType={setDataType}
            setDataId={setDataId}
            setHead={setHead}
            setLeagueId={setLeagueId}
            dataClient={dataClient}
          />
        )
      );
    case "match-page":
      return head ? (
        <Head
          matchDetail={headData}
          difference={difference}
          sport={sport}
          dataType={dataType}
          setDataType={setDataType}
          setDataId={setDataId}
          setHead={setHead}
          setLeagueId={setLeagueId}
          dataClient={dataClient}
        >
          <MatchPage
            data={data?.data}
            baseUrl={baseUrl}
            dataType={dataType}
            difference={difference}
            sport={sport}
            dataId={dataId}
            commData={otherData}
            loadCSS={loadCSS}
            headData={headData}
            setDataType={setDataType}
            setDataId={setDataId}
            setHead={setHead}
            setLeagueId={setLeagueId}
          />
        </Head>
      ) : (
        <MatchPage
          data={data?.data}
          baseUrl={baseUrl}
          dataType={dataType}
          difference={difference}
          sport={sport}
          dataId={dataId}
          commData={otherData}
          loadCSS={loadCSS}
          setDataType={setDataType}
          setDataId={setDataId}
          setHead={setHead}
          setLeagueId={setLeagueId}
        />
      );

    case "match-editorial":
      // Self-contained head: teams/score/status + goals/cards, no <Head> wrapper.
      // Pair the /loadwidget call with head=match so headData carries the detail.
      return (
        <EditorialHeader
          match={headData?.data}
          events={data?.summary?.timeline}
          sport={sport}
          difference={difference}
          loadCSS={loadCSS}
          dataClient={dataClient}
          dataId={dataId}
          baseUrl={baseUrl}
          socketUrl={socketUrl}
        />
      );

    default:
      return <h1>Widget Not Found in football Match!</h1>;
  }
};

export default MatchWidgetWrap;
